import axios from 'axios';

const httpGetFonts = () => {
  return axios.get('/api/v2/fonts');
};

export { httpGetFonts };
